import React, { useState, useCallback, useMemo } from 'react';
import { Fetcher, HTTPError } from '@this/src/util';
import type Trip from '@this/src/domain/trip/trip2';
import { Button } from '@this/shared/ui/inputs/button';
import { Text } from '@this/shared/ui/data_displays/typography';
import Notification from '@this/src/notification';

type Props = {
  className?: string;
  trip: Trip;
  onUpdate: () => void;
};

export const ReceiptRevision: React.FC<Props> = ({ className, trip, onUpdate }) => {
  const [submitting, setSubmitting] = useState(false);

  const allOrderItemsDone = useMemo(
    () => trip.currentOrder?.orderItems?.every(item => item.status === 7) || false,
    [trip.currentOrder]
  );

  const handleCompleteRevision = useCallback(async () => {
    if (submitting) return;

    setSubmitting(true);
    try {
      await Fetcher.put(`/arrangement/trips/${trip.id}/complete_receipt_revision`, {});
      Notification.success('領収書訂正を完了しました');
      onUpdate();
    } catch (e) {
      const msg =
        e instanceof HTTPError && e.response?.data?.errors
          ? e.response.data.errors
          : '領収書訂正の完了に失敗しました';
      Notification.error(msg);
    } finally {
      setSubmitting(false);
    }
  }, [submitting, trip.id, onUpdate]);

  return (
    <div className={className}>
      <h3>領収書訂正</h3>
      <p>
        領収書の訂正が必要な場合、
        <br />
        全てのorder_item_statusが完了してから下記のボタンを押してください
      </p>
      <div style={{ marginTop: 16 }}>
        <Button
          onClick={handleCompleteRevision}
          disabled={!allOrderItemsDone || submitting}
          loading={submitting}
          color="primary"
        >
          領収書訂正完了
        </Button>
      </div>
      {!allOrderItemsDone && (
        <Text color="danger" style={{ marginBottom: 8 }}>
          ※全てのorder_item_statusが完了するまでボタンは押せません
        </Text>
      )}
    </div>
  );
};
